export default __webpack_public_path__ + "static/smile-woman-edbc3c4209d2a251674f1b626890a915.jpg";